import { render } from "./unusedCoupon.vue?vue&type=template&id=9c117112&scoped=true"
import script from "./unusedCoupon.vue?vue&type=script&lang=js"
export * from "./unusedCoupon.vue?vue&type=script&lang=js"

import "./unusedCoupon.vue?vue&type=style&index=0&id=9c117112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c117112"]])

export default __exports__